import { IResourceComponentsProps } from "@pankod/refine-core";
import { MappingContract } from "./mapping";

export const ContractEdit: React.FC<IResourceComponentsProps> = () => {
  return <MappingContract mode="Add" />;
};
